/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StaffOverviewEntryUserType
 */
export interface StaffOverviewEntryUserType {
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    title?: string;
}

/**
 * Check if a given object implements the StaffOverviewEntryUserType interface.
 */
export function instanceOfStaffOverviewEntryUserType(value: object): value is StaffOverviewEntryUserType {
    return true;
}

export function StaffOverviewEntryUserTypeFromJSON(json: any): StaffOverviewEntryUserType {
    return StaffOverviewEntryUserTypeFromJSONTyped(json, false);
}

export function StaffOverviewEntryUserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffOverviewEntryUserType {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function StaffOverviewEntryUserTypeToJSON(json: any): StaffOverviewEntryUserType {
    return StaffOverviewEntryUserTypeToJSONTyped(json, false);
}

export function StaffOverviewEntryUserTypeToJSONTyped(value?: StaffOverviewEntryUserType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'title': value['title'],
    };
}

